import { select, put, takeLatest, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
	selectors as paymentDetailsSelectors,
	paymentProfileDetailsAdditionalSagas,
} from 'modules/api/billing/payment/profile/detailsModule';
import snackbarSaga from 'modules/snackbar/sagas/sagas';

import paymentActions from './paymentActions';

// Doing this the long way instead of just calling init because we need blocking calls
function* init() {
	if (!(yield select(paymentDetailsSelectors.hasData))) {
		yield call(paymentProfileDetailsAdditionalSagas.fetchDirectly);
	}
}

function* hasPaymentMethodCheck({ navigate } = {}) {
	yield call(init);
	if (yield select(paymentDetailsSelectors.getHasPaymentMethod)) {
		if (navigate) yield put(push('/shop/checkout'));
		return true;
	}
	yield call(snackbarSaga, {
		variant: 'info',
		successMessage: 'Please enter a payment method.',
	});
	if (navigate) yield put(push('/shop/payment-method'));
	return false;
}

export { hasPaymentMethodCheck, init };
export default function* paymentSagas() {
	yield takeLatest(paymentActions.BILLING_PAYMENT_METHOD_INIT, init);
}
